/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Edit_Criteria_TitleInputs */

const en_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Search Criteria`)
};

const de_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchkriterium bearbeiten`)
};

const fr_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le critère de recherche`)
};

const es_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar criterio de búsqueda`)
};

const it_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica criterio di ricerca`)
};

const nl_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekcriterium bewerken`)
};

const pl_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj kryterium wyszukiwania`)
};

const fi_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkaa hakukriteeriä`)
};

const da_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger søgekriterium`)
};

const sv_jobs_edit_criteria_title = /** @type {(inputs: Jobs_Edit_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redigera sökkriterium`)
};

/**
* | output |
* | --- |
* | "Edit Search Criteria" |
*
* @param {Jobs_Edit_Criteria_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_edit_criteria_title = /** @type {((inputs?: Jobs_Edit_Criteria_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Edit_Criteria_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_edit_criteria_title(inputs)
	if (locale === "fr") return fr_jobs_edit_criteria_title(inputs)
	if (locale === "es") return es_jobs_edit_criteria_title(inputs)
	if (locale === "it") return it_jobs_edit_criteria_title(inputs)
	if (locale === "nl") return nl_jobs_edit_criteria_title(inputs)
	if (locale === "pl") return pl_jobs_edit_criteria_title(inputs)
	if (locale === "fi") return fi_jobs_edit_criteria_title(inputs)
	if (locale === "da") return da_jobs_edit_criteria_title(inputs)
	if (locale === "sv") return sv_jobs_edit_criteria_title(inputs)
	return en_jobs_edit_criteria_title(inputs)
});